import { render, staticRenderFns } from "./NewFinalMemberAreaQuizz.vue?vue&type=template&id=3a800f6f&scoped=true&"
import script from "./NewFinalMemberAreaQuizz.vue?vue&type=script&lang=js&"
export * from "./NewFinalMemberAreaQuizz.vue?vue&type=script&lang=js&"
import style0 from "./NewFinalMemberAreaQuizz.vue?vue&type=style&index=0&id=3a800f6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a800f6f",
  null
  
)

export default component.exports